export class DeclarationReglementation {
    constructor(
        public id?: number,
        public dateCreation?: any,
        public declarationId?: number,
        public reglementationId?: number,
    ) {
    }
}
